// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__1p04Q","DotContainer":"Spinner_DotContainer__3kNvQ","Dot":"Spinner_Dot__2JgT4","fade":"Spinner_fade__1brFb"};